export class RoleInFilmModel 
{
    filmID:number;
    roleName:string;
    roleType:string;
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/models/roleinfilm.ts